import * as React from "react";
import type { SVGProps } from "react";
const SvgCheckMarkInSquare = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M10.2 16.6c.19.25.49.4.8.4h.04a.99.99 0 0 0 .81-.47l5-8a1.003 1.003 0 0 0-1.7-1.06l-4.23 6.76L8.8 11.4c-.33-.44-.96-.53-1.4-.2s-.53.96-.2 1.4z"
    />
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M5.84 22h12.32c2.12 0 3.84-1.72 3.84-3.84V5.84C22 3.72 20.28 2 18.16 2H5.84C3.72 2 2 3.72 2 5.84v12.32C2 20.28 3.72 22 5.84 22M4 5.84C4 4.83 4.82 4 5.84 4h12.32C19.17 4 20 4.82 20 5.84v12.32c0 1.01-.82 1.84-1.84 1.84H5.84C4.83 20 4 19.18 4 18.16z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgCheckMarkInSquare;
